const $ = require("jquery");

class CountryField {
	constructor (id) {
		this.id = id;
		this.$root = this.getRoot();
	}

	getRoot () {
		return this.$root ? this.$root : $(`#${this.id}`);
	}

	getSelect () {
		return this.getRoot().find("select");
	}
}

CountryField.init = () => {
	const objects = [];

	$('[data-component="country-field"]').each((i, e) => {
		const id = $(e).attr("id");
		objects.push(new CountryField(id));
	});

	return objects;
}

module.exports = CountryField;
